// extracted by mini-css-extract-plugin
export default {"textTotal":"TotalFieldPOProduct_textTotal__LvI0g"};